module.exports = __webpack_public_path__ + "static/media/Face.a4d0b62c.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/buttons/Face.PNG
// module id = 65
// module chunks = 0